import React, { useState, useEffect, useContext } from 'react';
import { Form, InputGroup, InputGroupAddon, Input } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { Title, SearchButton, Label } from './styles';
import FaqContext from '../../../../contexts/FAQContext';

export const SearchForm = props => {
  const { labels } = props;
  const [toSearch, setToSearch] = useState(undefined);
  const [term, setTerm] = useState('');
  const { setSearch, searchTerm, faqOriginal, category } = useContext(FaqContext);

  const doSearch = e => {
    e.preventDefault();
    if (term) {
      setSearch(term);
      setToSearch(true);
    }
    return false;
  };

  useEffect(() => {
    setTerm(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    setToSearch(false);
  }, [toSearch]);

  const updateTerm = e => setTerm(e.target.value);

  const searchTitle = faqOriginal.accountType ? faqOriginal.accountType.substr(faqOriginal.accountType.indexOf('-')+1) : '';
  
  return (
    <>
      {toSearch ? <Redirect to={`/faq/${category}/search/${term}`} /> : null}
      {faqOriginal ? (
        <>
          <Title className="pt-2 pt-sm-0 mt-1">{`${searchTitle} FAQs`}</Title>
          <Form className="col-lg-5 p-lg-0 p-0" onSubmit={doSearch}>
            <Label htmlFor="search-term">{labels.inputTextHint}</Label>
            <InputGroup>
              <Input
                aria-label={labels.inputTextHint}
                id="search-term"
                type="text"
                placeholder={labels.inputTextHint}
                value={term}
                onChange={updateTerm}
              />
              <InputGroupAddon addonType="append">
                <SearchButton type="submit">{labels.searchButtonText}</SearchButton>
              </InputGroupAddon>
            </InputGroup>
          </Form>
        </>
      ) : null}
    </>
  );
};
